const importAll = context => {
  const modules = {};
  for (const key of context.keys()) {
//    console.log(key);
    const match = key.match(/^\.\/([a-z0-9_-]+).jsx$/);
    if (match) {
      const name = match[1];
      modules[name] = context(key)[name];
    }
  }
  return modules;
};
const webPackContext = require.context("./", true, /^\.\/([a-z0-9_-]+).jsx$/);
const modules = importAll(webPackContext);

module.exports = modules;



// WEBPACK FOOTER //
// ./common/modal/index.js